import * as React from 'react';
import { useRouter } from 'next/router';
import { Breadcrumbs, Link, Typography } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  link: {
    color: '#3C8047',
    fontFamily: 'Lato',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '14px',
    textTransform: 'uppercase',
  },
}));
export default function DynamicBreadcrumbs() {
  const router = useRouter();
  const classes = useStyles();

  const pathnames = router.asPath.split('/').filter((x) => x);

  const handleClick = (event, path) => {
    event.preventDefault();
    router.push(path);
  };

  return (
    <Breadcrumbs aria-label="breadcrumb">
      <Link
        className={classes.link}
        underline="hover"
        color="inherit"
        href="/"
        onClick={(e) => handleClick(e, '/')}
      >
        HOME
      </Link>
      {pathnames.map((value, index) => {
        const to = `/${pathnames.slice(0, index + 1).join('/')}`;
        const isLast = index === pathnames.length - 1;
        return isLast ? (
          <Typography
            key={to}
            className={classes.link}
            style={{ color: '#000' }}
          >
            {value.toUpperCase()}
          </Typography>
        ) : (
          <Link
            key={to}
            className={classes.link}
            underline="hover"
            color="inherit"
            href={to}
            onClick={(e) => handleClick(e, to)}
          >
            {value.toUpperCase()}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
}
